import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-chronology-readonly',
    templateUrl: './chronology-readonly.component.html',
    styleUrl: './chronology-readonly.component.scss'
})
export class ChronologyReadonlyComponent {

  @Input() chronologyData: any = null;

}
